import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpConfigInterceptor } from './interceptor/http.interceptor';
import { MessageService } from 'primeng/api';
import { AuthGuard } from './guard/auth.guard';
import { PublicGuard } from './guard/public.guard';
import { SignupGuard } from './guard/signup.guard';
import { SystemUserGuard } from './guard/system-user.guard';
import { NotSelfGuard } from './guard/not-self.guard';
import { TenantGuard } from './guard/tenant.guard';
import { ShoppingStoreGuard } from './guard/shopping-store.guard';
import { AuthService } from '../auth/services/auth.service';
import { AuthorizationGuard } from './guard/authorization.guard';
import { PermissionAccessService } from '../shared/services/permission-access.service';

@NgModule({
    providers: [
        MessageService,
        // SignupGuard reads the shop list through it. AuthService is not
        // root-provided, so every module that reaches it provides its own -
        // harmless, since it holds no state beyond HttpClient.
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true,
        },
        // The one permission check in the app, and the only service here that
        // holds state - a store subscription. It sits with the singletons
        // rather than in SharedModule, which every lazy module imports and
        // would therefore give its own copy.
        PermissionAccessService,
        AuthGuard,
        PublicGuard,
        SignupGuard,
        SystemUserGuard,
        NotSelfGuard,
        TenantGuard,
        ShoppingStoreGuard,
        AuthorizationGuard,
    ],
})
export class CoreModule {}
